import { Handle, Position } from '@xyflow/react'

interface Data {
  name: string
  summary: string
  metric: string
  selected: boolean
}

export default function AlgorithmNode({ data }: { data: Data }) {
  return (
    <div
      className={
        'w-[224px] cursor-pointer rounded-xl border px-3.5 py-2.5 transition-all ' +
        (data.selected
          ? 'border-accent-500/80 bg-ink-800 shadow-glow-accent'
          : 'border-ink-600 bg-ink-850 hover:border-accent-500/50 hover:bg-ink-800')
      }
    >
      <Handle type="target" position={Position.Left} className="!h-2 !w-2 !border-0 !bg-ink-600" />
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm font-semibold text-white">{data.name}</div>
        <span className="rounded-md bg-accent-500/15 px-1.5 py-0.5 text-[10px] font-medium text-accent-400">
          {data.metric}
        </span>
      </div>
      <div className="mt-1 text-[12px] leading-snug text-mut">{data.summary}</div>
      <Handle type="source" position={Position.Right} className="!h-2 !w-2 !border-0 !bg-ink-600" />
    </div>
  )
}
